import type {
  InputCssVar,
  MultiChipInputCssVar,
  SelectCssVar,
} from '@revelio/ui';

import type { NestedFilterSelectCssVar } from './NestedFilterSelect/NestedFilterSelect';

export const customFilterSelectCssVars: Partial<Record<SelectCssVar, string>> =
  {
    '--select-disabled-bg': '#ffffff30',
    '--select-disabled-border': '#e2e8f0',
    '--select-disabled-color': '#71809680',
  };

export const customFilterNestedFilterSelectCssVars: Partial<
  Record<NestedFilterSelectCssVar, string>
> = {
  '--nested-filter-select-disabled-bg': '#ffffff30',
  '--nested-filter-select-disabled-border': '#e2e8f0',
  '--nested-filter-select-disabled-color': '#71809680',
};

export const customFilterInputCssVars: Partial<Record<InputCssVar, string>> = {
  '--input-disabled-bg': '#ffffff30',
  '--input-disabled-border': '#e2e8f0',
  '--input-disabled-color': '#71809680',
  '--input-disabled-placeholder-color': '#71809680',
};

export const customFilterMultiChipInputCssVars: Partial<
  Record<MultiChipInputCssVar, string>
> = {
  '--multi-chip-input-disabled-bg': '#ffffff30',
  '--multi-chip-input-disabled-border': '#e2e8f0',
  '--multi-chip-input-disabled-color': '#71809680',
  '--multi-chip-input-disabled-placeholder-color': '#71809680',
  '--multi-chip-input-chip-disabled-bg': '#ffffff30',
  '--multi-chip-input-chip-disabled-border': '#e2e8f0',
  '--multi-chip-input-chip-disabled-color': '#71809680',
};
